import { Pill } from './ui';
import { Link } from "react-router-dom";
const stats = [['100%', 'Verified Audit Standard'], ['Up to 20%', 'Contractual Tier Rate'], ['30-Day', 'Grace Protection Window'], ['SHA-256', 'Digital Credential Registry']];
const links = ['Terms of Representation', 'Privacy Charter', 'Anti-Sybil Guidelines'];

export default function CtaFooter() {
  return (
    <>
      <section className="bg-navy text-white text-center py-5"><div className="container py-lg-4">
        <Pill cls="bg-navy2 text-gold">Connect • Grow • Rank • Earn • Lead</Pill>
        <h2 className="fw-bold text-uppercase t-xl mt-4">Your network can take you further</h2>
        <p className="text-white-50 mx-auto" style={{ maxWidth: 560 }}>Step into an institutional tier-based network engineered for transparency, prestige, and tangible economic return. Begin your accreditation journey today.</p>
        <div className="d-flex flex-wrap justify-content-center gap-3 my-4">
          <button className="btn bg-gold text-navy fw-bold rounded-3 px-4 py-3">Become a Marketing Agent <i className="bi bi-arrow-right ms-2" /></button>
          <button className="btn btn-outline-light fw-bold rounded-3 px-4 py-3">Explore 10-Star Journey</button>
        </div>
        <div className="row g-3 bg-navy2 rounded-4 py-4 mt-5 mx-0">{stats.map(([a, b]) => <div className="col-6 col-lg-3" key={a}><div className="text-gold fw-bold">{a}</div><div className="t-sm">{b}</div></div>)}</div>
      </div></section>
     <footer className="selectezi-footer p-3">
  <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
    <span>
      &copy; 2025 SELECTEZI Inc. All rights reserved.
    </span>

    <div className="d-flex align-items-center gap-3">
      <Link to="/general-terms">General Terms</Link>
      <Link to="/privacy-policy">Privacy Policy</Link>
    </div>
  </div>
</footer>
    </>
  );
}
